(function() {
  const quickViewModal = document.querySelector('[data-quick-view]');
  if (!quickViewModal) return;

  const closeButtons = quickViewModal.querySelectorAll('[data-quick-view-close]');
  const loadingEl = quickViewModal.querySelector('[data-quick-view-loading]');
  const productEl = quickViewModal.querySelector('[data-quick-view-product]');
  const imageEl = quickViewModal.querySelector('[data-quick-view-image]');
  const thumbnailsEl = quickViewModal.querySelector('[data-quick-view-thumbnails]');
  const badgesEl = quickViewModal.querySelector('[data-quick-view-badges]');
  const vendorEl = quickViewModal.querySelector('[data-quick-view-vendor]');
  const titleEl = quickViewModal.querySelector('[data-quick-view-title]');
  const priceEl = quickViewModal.querySelector('[data-quick-view-price]');
  const variantsEl = quickViewModal.querySelector('[data-quick-view-variants]');
  const variantIdInput = quickViewModal.querySelector('[data-quick-view-variant-id]');
  const quantityInput = quickViewModal.querySelector('[data-quick-view-quantity]');
  const qtyMinusBtn = quickViewModal.querySelector('[data-quick-view-qty-minus]');
  const qtyPlusBtn = quickViewModal.querySelector('[data-quick-view-qty-plus]');
  const addBtn = quickViewModal.querySelector('[data-quick-view-add]');
  const form = quickViewModal.querySelector('[data-quick-view-form]');
  const viewLink = quickViewModal.querySelector('[data-quick-view-link]');

  let currentProduct = null;
  let selectedOptions = {};

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function open(productHandle) {
    quickViewModal.hidden = false;
    document.body.style.overflow = 'hidden';
    loadingEl.hidden = false;
    productEl.hidden = true;
    loadProduct(productHandle);
  }

  function close() {
    quickViewModal.hidden = true;
    document.body.style.overflow = '';
    currentProduct = null;
    selectedOptions = {};
  }

  async function loadProduct(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      currentProduct = product;
      renderProduct(product);
    } catch (error) {
      console.error('Quick view error:', error);
      close();
    }
  }

  function renderProduct(product) {
    // Set image
    if (product.featured_image) {
      imageEl.src = product.featured_image;
      imageEl.alt = product.title;
    }

    // Set thumbnails
    thumbnailsEl.innerHTML = product.images.slice(0, 5).map((img, index) => `
      <img
        src="${img}"
        alt="${product.title} - Image ${index + 1}"
        class="quick-view-modal__thumbnail${index === 0 ? ' quick-view-modal__thumbnail--active' : ''}"
        data-quick-view-thumb="${index}"
        width="64"
        height="64"
      >
    `).join('');

    // Add thumbnail click handlers
    thumbnailsEl.querySelectorAll('[data-quick-view-thumb]').forEach(thumb => {
      thumb.addEventListener('click', function() {
        thumbnailsEl.querySelectorAll('.quick-view-modal__thumbnail--active').forEach(t => t.classList.remove('quick-view-modal__thumbnail--active'));
        this.classList.add('quick-view-modal__thumbnail--active');
        imageEl.src = this.src.replace('64x64', '500x500');
      });
    });

    // Set badges
    let badgesHtml = '';
    if (product.tags && (product.tags.includes('nicotine') || product.tags.includes('21+'))) {
      badgesHtml += '<span class="quick-view-modal__badge quick-view-modal__badge--age">21+</span>';
    }
    if (product.compare_at_price && product.compare_at_price > product.price) {
      badgesHtml += '<span class="quick-view-modal__badge quick-view-modal__badge--sale">Sale</span>';
    }
    badgesEl.innerHTML = badgesHtml;

    // Set vendor
    vendorEl.textContent = product.vendor || '';
    vendorEl.hidden = !product.vendor;

    // Set title
    titleEl.textContent = product.title;

    // Set variants (this will also set initial price and variant ID)
    renderVariants(product);

    // Set view link
    viewLink.href = product.url;

    // Show product
    loadingEl.hidden = true;
    productEl.hidden = false;
  }

  function updatePrice(variant) {
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = `
        <span class="quick-view-modal__price-sale">${formatMoney(variant.price)}</span>
        <span class="quick-view-modal__price-compare">${formatMoney(variant.compare_at_price)}</span>
      `;
    } else {
      priceEl.innerHTML = formatMoney(variant.price);
    }

    // Update add button
    if (variant.available) {
      addBtn.disabled = false;
      addBtn.innerHTML = `
        <svg class="quick-view-modal__add-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <path d="M16 10a4 4 0 0 1-8 0"></path>
        </svg>
        <span>Add to Cart</span>
      `;
    } else {
      addBtn.disabled = true;
      addBtn.innerHTML = '<span>Sold Out</span>';
    }
  }

  function renderVariants(product) {
    // For simple products with no meaningful options
    if (!product.options || product.options.length === 0 || (product.options.length === 1 && product.options[0].name === 'Title')) {
      variantsEl.innerHTML = '';
      // Still set price and variant ID for simple products
      const variant = product.variants[0];
      variantIdInput.value = variant.id;
      updatePrice(variant);
      return;
    }

    // Initialize selected options with first available variant
    const firstAvailableVariant = product.variants.find(v => v.available) || product.variants[0];
    product.options.forEach((option, index) => {
      selectedOptions[option.name] = firstAvailableVariant.options[index];
    });

    // Helper function to check if an option value has any available variants
    function isOptionValueAvailable(optionName, optionValue, optionIndex) {
      return product.variants.some(variant => {
        return variant.options[optionIndex] === optionValue && variant.available;
      });
    }

    variantsEl.innerHTML = product.options.map((option, optionIndex) => {
      const values = [...new Set(product.variants.map(v => v.options[optionIndex]))];

      return `
        <div class="quick-view-modal__variant-group">
          <span class="quick-view-modal__variant-label">${option.name}</span>
          <div class="quick-view-modal__variant-options">
            ${values.map(value => {
              const isActive = selectedOptions[option.name] === value;
              const isAvailable = isOptionValueAvailable(option.name, value, optionIndex);
              const classes = [
                'quick-view-modal__variant-btn',
                isActive ? 'quick-view-modal__variant-btn--active' : '',
                !isAvailable ? 'quick-view-modal__variant-btn--unavailable' : ''
              ].filter(Boolean).join(' ');

              return `
                <button
                  type="button"
                  class="${classes}"
                  data-option-name="${option.name}"
                  data-option-value="${value}"
                  ${!isAvailable ? 'disabled aria-disabled="true"' : ''}
                  ${!isAvailable ? 'title="Out of Stock"' : ''}
                >
                  ${value}
                </button>
              `;
            }).join('')}
          </div>
        </div>
      `;
    }).join('');

    // Add variant button handlers (only for available options)
    variantsEl.querySelectorAll('.quick-view-modal__variant-btn:not([disabled])').forEach(btn => {
      btn.addEventListener('click', function() {
        const optionName = this.dataset.optionName;
        const optionValue = this.dataset.optionValue;

        // Update selected options
        selectedOptions[optionName] = optionValue;

        // Update active state
        this.closest('.quick-view-modal__variant-options').querySelectorAll('.quick-view-modal__variant-btn').forEach(b => {
          b.classList.remove('quick-view-modal__variant-btn--active');
        });
        this.classList.add('quick-view-modal__variant-btn--active');

        // Find matching variant
        const selectedVariant = currentProduct.variants.find(v => {
          return currentProduct.options.every((opt, index) => {
            return v.options[index] === selectedOptions[opt.name];
          });
        });

        if (selectedVariant) {
          variantIdInput.value = selectedVariant.id;
          updatePrice(selectedVariant);

          // Update image if variant has one
          if (selectedVariant.featured_image) {
            imageEl.src = selectedVariant.featured_image.src;
          }
        }
      });
    });

    // Set initial variant ID to first available
    variantIdInput.value = firstAvailableVariant.id;
    updatePrice(firstAvailableVariant);
  }

  // Quantity buttons
  qtyMinusBtn.addEventListener('click', function() {
    const currentQty = parseInt(quantityInput.value) || 1;
    if (currentQty > 1) {
      quantityInput.value = currentQty - 1;
    }
  });

  qtyPlusBtn.addEventListener('click', function() {
    const currentQty = parseInt(quantityInput.value) || 1;
    quantityInput.value = currentQty + 1;
  });

  // Form submit
  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    const variantId = variantIdInput.value;
    const quantity = parseInt(quantityInput.value) || 1;

    addBtn.classList.add('quick-view-modal__add-btn--loading');
    addBtn.innerHTML = `
      <svg class="quick-view-modal__add-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 6v6l4 2"/>
      </svg>
      <span>Adding...</span>
    `;

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (response.ok) {
        addBtn.classList.add('quick-view-modal__add-btn--success');
        addBtn.innerHTML = `
          <svg class="quick-view-modal__add-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M20 6L9 17l-5-5"/>
          </svg>
          <span>Added!</span>
        `;

        // Update cart count
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach(el => {
          el.textContent = cart.item_count;
        });

        // Open cart drawer if available
        if (window.FullSend?.CartDrawer) {
          setTimeout(() => {
            close();
            window.FullSend.CartDrawer.open();
          }, 600);
        } else {
          setTimeout(() => {
            addBtn.classList.remove('quick-view-modal__add-btn--loading', 'quick-view-modal__add-btn--success');
            updatePrice(currentProduct.variants.find(v => v.id == variantId) || currentProduct.variants[0]);
          }, 1800);
        }
      } else {
        throw new Error('Failed to add to cart');
      }
    } catch (error) {
      console.error('Add to cart error:', error);
      addBtn.innerHTML = '<span>Error - Try Again</span>';
      addBtn.classList.remove('quick-view-modal__add-btn--loading');
      setTimeout(() => {
        updatePrice(currentProduct.variants.find(v => v.id == variantId) || currentProduct.variants[0]);
      }, 2000);
    }
  });

  // Close handlers
  closeButtons.forEach(btn => {
    btn.addEventListener('click', close);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && !quickViewModal.hidden) {
      close();
    }
  });

  // Expose globally
  window.FullSend = window.FullSend || {};
  window.FullSend.QuickView = { open, close };
})();
